//记得在 src\components\lang\zhLoad.js 里面添加对象
const ssoLoading = {
  msg: {
  }
};
export default ssoLoading



// WEBPACK FOOTER //
// ./src/page/sso/ssoError/lang/ssoError.zh.js